import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { first, find } from 'lodash';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import masterField from '../../../../components/search-form/master-field';

// Import Selectors

const periods = [
  { label: 'Weekly', value: 'week' },
  { label: 'Monthly', value: 'month' },
  { label: '60 Day', value: '60-day' },
  { label: '90 Day', value: '90-day' },
];
class HistoryPeriodField extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.selectPeriod = this.selectPeriod.bind(this);
  }

  selectPeriod(value) {
    this.props.onChange(value);
  }


  render() {
    const { disabled, value } = this.props;
    const active = find(periods, { value }) || first(periods);

    return (
      <div>
        <div>
          <DropdownButton
            onSelect={this.selectPeriod}
            disabled={disabled}
            bsSize="sm"
            title={active ? active.label : 'Period'}
            id="history-period"
          >
            {periods.map(period => (
              <MenuItem
                active={active.value === period.value}
                disabled={disabled}
                key={period.value}
                eventKey={period.value}
              >
                {period.label}
              </MenuItem>
              ))}
          </DropdownButton>
        </div>
      </div>
    );
  }
}

HistoryPeriodField.propTypes = {
  dispatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
HistoryPeriodField.defaultProps = {
  onChange: () => {},
};
export default masterField(HistoryPeriodField);
